import { render } from "./MenuLabel.vue?vue&type=template&id=3ac688fb&ts=true"
import script from "./MenuLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuLabel.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuLabel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ac688fb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ac688fb', __exports__)) {
    api.reload('3ac688fb', __exports__)
  }
  
  module.hot.accept("./MenuLabel.vue?vue&type=template&id=3ac688fb&ts=true", () => {
    api.rerender('3ac688fb', render)
  })

}


export default __exports__